<script>
	export let offset;
	import {scaleLinear} from "d3-scale";
	
	let innerWidth = 0;
	$: isMobile = innerWidth < 600;
	
	$: offsetValStarFadeIn = isMobile ? 0.4 : 0.7;
	$: x0 = isMobile ? 0.1 : 0;
    $: interpolateTransformX = scaleLinear()
        .domain([x0, offsetValStarFadeIn])
        .range([0, 100])

    $: transformX = Math.min(Math.max(interpolateTransformX(offset), 0), 200 )

</script>

<svelte:window bind:innerWidth />

<!-- <mark>{innerWidth}, {offset}</mark> -->

<svg version="1.1" id="IlloTurf" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 320 200" style="enable-background:new 0 0 320 200;" xml:space="preserve">
	 <rect y="-121.9" class="st0" width="320" height="320"/>
	 <g id="MachineBack">
		 <rect x="138" y="125.1" class="st1" width="80" height="36.9"/>
	 </g>
	 <g id="MachineBase">
		 <polygon class="st1" points="20.6,162 317.5,162 299.6,180.2 2.5,180.2 	"/>
		 <rect x="2.5" y="180.2" class="st1" width="297.1" height="12.6"/>
		 <polygon id="_x3C_Path_x3E_" class="st1" points="299.6,180.2 299.6,192.7 317.5,174.8 317.5,162 	"/>
	 </g>
	 <g id="Wheels">
		 <g>
			 <circle class="st2" cx="31.7" cy="186.4" r="5.1"/>
			 <line class="st3" x1="33.8" y1="186.4" x2="29.3" y2="186.4"/>
			 <line class="st3" x1="31.6" y1="188.6" x2="31.6" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="43.1" cy="186.4" r="5.1"/>
			 <line class="st3" x1="45.2" y1="186.4" x2="40.7" y2="186.4"/>
			 <line class="st3" x1="43" y1="188.6" x2="43" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="54.5" cy="186.4" r="5.1"/>
			 <line class="st3" x1="56.6" y1="186.4" x2="52.1" y2="186.4"/>
			 <line class="st3" x1="54.3" y1="188.6" x2="54.3" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="65.9" cy="186.4" r="5.1"/>
			 <line class="st3" x1="68" y1="186.4" x2="63.5" y2="186.4"/>
			 <line class="st3" x1="65.7" y1="188.6" x2="65.7" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="77.2" cy="186.4" r="5.1"/>
			 <line class="st3" x1="79.3" y1="186.4" x2="74.8" y2="186.4"/>
			 <line class="st3" x1="77.1" y1="188.6" x2="77.1" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="88.6" cy="186.4" r="5.1"/>
			 <line class="st3" x1="90.7" y1="186.4" x2="86.2" y2="186.4"/>
			 <line class="st3" x1="88.5" y1="188.6" x2="88.5" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="100" cy="186.4" r="5.1"/>
			 <line class="st3" x1="102.1" y1="186.4" x2="97.6" y2="186.4"/>
			 <line class="st3" x1="99.9" y1="188.6" x2="99.9" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="111.4" cy="186.4" r="5.1"/>
			 <line class="st3" x1="113.5" y1="186.4" x2="109" y2="186.4"/>
			 <line class="st3" x1="111.2" y1="188.6" x2="111.2" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="122.8" cy="186.4" r="5.1"/>
			 <line class="st3" x1="124.9" y1="186.4" x2="120.4" y2="186.4"/>
			 <line class="st3" x1="122.6" y1="188.6" x2="122.6" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="134.1" cy="186.4" r="5.1"/>
			 <line class="st3" x1="136.2" y1="186.4" x2="131.8" y2="186.4"/>
			 <line class="st3" x1="134" y1="188.6" x2="134" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="145.5" cy="186.4" r="5.1"/>
			 <line class="st3" x1="147.6" y1="186.4" x2="143.1" y2="186.4"/>
			 <line class="st3" x1="145.4" y1="188.6" x2="145.4" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="156.9" cy="186.4" r="5.1"/>
			 <line class="st3" x1="159" y1="186.4" x2="154.5" y2="186.4"/>
			 <line class="st3" x1="156.8" y1="188.6" x2="156.8" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="168.3" cy="186.4" r="5.1"/>
			 <line class="st3" x1="170.4" y1="186.4" x2="165.9" y2="186.4"/>
			 <line class="st3" x1="168.1" y1="188.6" x2="168.1" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="179.7" cy="186.4" r="5.1"/>
			 <line class="st3" x1="181.8" y1="186.4" x2="177.3" y2="186.4"/>
			 <line class="st3" x1="179.5" y1="188.6" x2="179.5" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="191" cy="186.4" r="5.1"/>
			 <line class="st3" x1="193.1" y1="186.4" x2="188.6" y2="186.4"/>
			 <line class="st3" x1="190.9" y1="188.6" x2="190.9" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="202.4" cy="186.4" r="5.1"/>
			 <line class="st3" x1="204.5" y1="186.4" x2="200" y2="186.4"/>
			 <line class="st3" x1="202.3" y1="188.6" x2="202.3" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="213.8" cy="186.4" r="5.1"/>
			 <line class="st3" x1="215.9" y1="186.4" x2="211.4" y2="186.4"/>
			 <line class="st3" x1="213.6" y1="188.6" x2="213.6" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="225.2" cy="186.4" r="5.1"/>
			 <line class="st3" x1="227.3" y1="186.4" x2="222.8" y2="186.4"/>
			 <line class="st3" x1="225" y1="188.6" x2="225" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="236.6" cy="186.4" r="5.1"/>
			 <line class="st3" x1="238.6" y1="186.4" x2="234.2" y2="186.4"/>
			 <line class="st3" x1="236.4" y1="188.6" x2="236.4" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="247.9" cy="186.4" r="5.1"/>
			 <line class="st3" x1="250" y1="186.4" x2="245.5" y2="186.4"/>
			 <line class="st3" x1="247.8" y1="188.6" x2="247.8" y2="184.1"/>
		 </g>
		 <g>
			 
				 <ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 33.7899 412.4953)" class="st2" cx="259.3" cy="186.4" rx="5.1" ry="5.1"/>
			 <line class="st3" x1="261.4" y1="186.4" x2="256.9" y2="186.4"/>
			 <line class="st3" x1="259.2" y1="188.6" x2="259.2" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="270.7" cy="186.4" r="5.1"/>
			 <line class="st3" x1="272.8" y1="186.4" x2="268.3" y2="186.4"/>
			 <line class="st3" x1="270.5" y1="188.6" x2="270.5" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="282.1" cy="186.4" r="5.1"/>
			 <line class="st3" x1="284.2" y1="186.4" x2="279.7" y2="186.4"/>
			 <line class="st3" x1="281.9" y1="188.6" x2="281.9" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="293.5" cy="186.4" r="5.1"/>
			 <line class="st3" x1="295.5" y1="186.4" x2="291.1" y2="186.4"/>
			 <line class="st3" x1="293.3" y1="188.6" x2="293.3" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="9" cy="186.4" r="5.1"/>
			 <line class="st3" x1="11.1" y1="186.4" x2="6.6" y2="186.4"/>
			 <line class="st3" x1="8.8" y1="188.6" x2="8.8" y2="184.1"/>
		 </g>
		 <g>
			 <circle class="st2" cx="20.4" cy="186.4" r="5.1"/>
			 <line class="st3" x1="22.5" y1="186.4" x2="18" y2="186.4"/>
			 <line class="st3" x1="20.2" y1="188.6" x2="20.2" y2="184.1"/>
		 </g>
	 </g>

	 <g id="Stars1" class:show="{offset > offsetValStarFadeIn}">
		<path class="st14" d="M181.6,98.3c0.8-0.7,1.3-1.7,1.3-2.8c0-2.1-1.7-3.8-3.8-3.8c-0.8,0-1.5,0.2-2.1,0.6c-0.5-1.5-1.9-2.5-3.6-2.5
			s-3.1,1.1-3.6,2.5c-0.6-0.4-1.3-0.6-2.1-0.6c-2.1,0-3.8,1.7-3.8,3.8c0,1.1,0.5,2.1,1.3,2.8c-0.8,0.7-1.3,1.7-1.3,2.8
			c0,2.1,1.7,3.8,3.8,3.8c0.8,0,1.5-0.2,2.1-0.6c0.5,1.5,1.9,2.5,3.6,2.5s3.1-1.1,3.6-2.5c0.6,0.4,1.3,0.6,2.1,0.6
			c2.1,0,3.8-1.7,3.8-3.8C182.9,100,182.4,99,181.6,98.3z"/>
		<path class="st14" d="M122.2,105c0,0,2.3,0.3,4.3,2.3c2,2,2.3,4.3,2.3,4.3s0.7-2.6,2.3-4.3c1.6-1.7,4.3-2.3,4.3-2.3
			s-2.3-0.3-4.3-2.3c-2-2-2.3-4.3-2.3-4.3s-0.7,2.6-2.3,4.3C124.9,104.3,122.2,105,122.2,105z"/>
		<path class="st14" d="M231.8,100.6c0,0,0.3,2.4-1.4,4.1c-1.6,1.6-4.1,1.4-4.1,1.4s2.7,0,4.1,1.4c1.4,1.4,1.4,4.1,1.4,4.1
			s-0.3-2.4,1.4-4.1s4.1-1.4,4.1-1.4s-2.7,0-4.1-1.4C231.8,103.3,231.8,100.6,231.8,100.6z"/>
		
			<rect x="195.4" y="65.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 9.8775 159.2578)" class="st15" width="3.6" height="3.6"/>
		
			<rect x="212.1" y="87.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -0.5183 177.3987)" class="st15" width="3.6" height="3.6"/>
	</g>
	<g id="Stars2" class:show="{offset > offsetValStarFadeIn}">
		<path class="st14" d="M96.7,91.9c0.8-0.7,1.3-1.7,1.3-2.8c0-2.1-1.7-3.8-3.8-3.8c-0.8,0-1.5,0.2-2.1,0.6c-0.5-1.5-1.9-2.5-3.6-2.5
			s-3.1,1.1-3.6,2.5c-0.6-0.4-1.3-0.6-2.1-0.6c-2.1,0-3.8,1.7-3.8,3.8c0,1.1,0.5,2.1,1.3,2.8c-0.8,0.7-1.3,1.7-1.3,2.8
			c0,2.1,1.7,3.8,3.8,3.8c0.8,0,1.5-0.2,2.1-0.6c0.5,1.5,1.9,2.5,3.6,2.5s3.1-1.1,3.6-2.5c0.6,0.4,1.3,0.6,2.1,0.6
			c2.1,0,3.8-1.7,3.8-3.8C97.9,93.6,97.4,92.6,96.7,91.9z"/>
		<path class="st14" d="M170.3,61.7c0.8-0.7,1.3-1.7,1.3-2.8c0-2.1-1.7-3.8-3.8-3.8c-0.8,0-1.5,0.2-2.1,0.6c-0.5-1.5-1.9-2.5-3.6-2.5
			s-3.1,1.1-3.6,2.5c-0.6-0.4-1.3-0.6-2.1-0.6c-2.1,0-3.8,1.7-3.8,3.8c0,1.1,0.5,2.1,1.3,2.8c-0.8,0.7-1.3,1.7-1.3,2.8
			c0,2.1,1.7,3.8,3.8,3.8c0.8,0,1.5-0.2,2.1-0.6c0.5,1.5,1.9,2.5,3.6,2.5s3.1-1.1,3.6-2.5c0.6,0.4,1.3,0.6,2.1,0.6
			c2.1,0,3.8-1.7,3.8-3.8C171.5,63.4,171,62.4,170.3,61.7z"/>
		<path class="st14" d="M267.3,86.4c0.8-0.7,1.3-1.7,1.3-2.8c0-2.1-1.7-3.8-3.8-3.8c-0.8,0-1.5,0.2-2.1,0.6c-0.5-1.5-1.9-2.5-3.6-2.5
			s-3.1,1.1-3.6,2.5c-0.6-0.4-1.3-0.6-2.1-0.6c-2.1,0-3.8,1.7-3.8,3.8c0,1.1,0.5,2.1,1.3,2.8c-0.8,0.7-1.3,1.7-1.3,2.8
			c0,2.1,1.7,3.8,3.8,3.8c0.8,0,1.5-0.2,2.1-0.6c0.5,1.5,1.9,2.5,3.6,2.5s3.1-1.1,3.6-2.5c0.6,0.4,1.3,0.6,2.1,0.6
			c2.1,0,3.8-1.7,3.8-3.8C268.6,88.1,268.1,87.1,267.3,86.4z"/>
		<path class="st14" d="M222.6,57.8c0,0,2.3,0.3,4.3,2.3c2,2,2.3,4.3,2.3,4.3s0.7-2.6,2.3-4.3s4.3-2.3,4.3-2.3s-2.3-0.3-4.3-2.3
			s-2.3-4.3-2.3-4.3s-0.7,2.6-2.3,4.3C225.2,57.2,222.6,57.8,222.6,57.8z"/>
		<path class="st14" d="M115.5,70c0,0,0.3,2.4-1.4,4.1c-1.6,1.6-4.1,1.4-4.1,1.4s2.7,0,4.1,1.4c1.4,1.4,1.4,4.1,1.4,4.1
			s-0.3-2.4,1.4-4.1s4.1-1.4,4.1-1.4s-2.7,0-4.1-1.4C115.5,72.7,115.5,70,115.5,70z"/>
	</g>
	<g id="Stars3" class:show="{offset > offsetValStarFadeIn}">
		<path class="st14" d="M116.2,21.9c0,0,2.3,0.3,4.3,2.3c2,2,2.3,4.3,2.3,4.3s0.7-2.6,2.3-4.3s4.3-2.3,4.3-2.3s-2.3-0.3-4.3-2.3
			s-2.3-4.3-2.3-4.3s-0.7,2.6-2.3,4.3S116.2,21.9,116.2,21.9z"/>
		<path class="st14" d="M94.9,44.7c0,0,0.3,2.4-1.4,4c-1.6,1.6-4.1,1.4-4.1,1.4s2.7,0,4.1,1.4c1.4,1.4,1.4,4,1.4,4s-0.3-2.4,1.4-4
			c1.6-1.6,4.1-1.4,4.1-1.4s-2.7,0-4.1-1.4C94.9,47.4,94.9,44.7,94.9,44.7z"/>
		<path class="st14" d="M238.6,23.3c0,0,0.3,2.4-1.4,4s-4.1,1.4-4.1,1.4s2.7,0,4.1,1.4c1.4,1.4,1.4,4,1.4,4s-0.3-2.4,1.4-4
			c1.6-1.6,4.1-1.4,4.1-1.4s-2.7,0-4.1-1.4C238.7,26,238.6,23.3,238.6,23.3z"/>
		<rect x="127" y="45.8" transform="matrix(0.7071 -0.7071 0.7071 0.7071 4.0499 105.0238)" class="st15" width="3.6" height="3.6"/>
		
			<rect x="166.5" y="21.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 32.8337 125.8076)" class="st15" width="3.6" height="3.6"/>
		<path class="st14" d="M210.6,23.3c0.8-0.7,1.3-1.7,1.3-2.8c0-2.1-1.7-3.8-3.8-3.8c-0.8,0-1.5,0.2-2.1,0.6c-0.5-1.5-1.9-2.5-3.6-2.5
			s-3.1,1.1-3.6,2.5c-0.6-0.4-1.3-0.6-2.1-0.6c-2.1,0-3.8,1.7-3.8,3.8c0,1.1,0.5,2.1,1.3,2.8c-0.8,0.7-1.3,1.7-1.3,2.8
			c0,2.1,1.7,3.8,3.8,3.8c0.8,0,1.5-0.2,2.1-0.6c0.5,1.5,1.9,2.5,3.6,2.5s3.1-1.1,3.6-2.5c0.6,0.4,1.3,0.6,2.1,0.6
			c2.1,0,3.8-1.7,3.8-3.8C211.9,25,211.4,24,210.6,23.3z"/>
	</g>	
	 <g id="Squares" style="transform: translate({transformX}px, 0px);">
		 <g id="Square2">
			 <g id="SquareBase2">
				 <polygon class="{offset < offsetValStarFadeIn ? 'st4' : 'st4b'}" points="59.6,169 59.6,176.3 70.1,165.8 70.1,158.3 			"/>
				 <rect x="26.9" y="169.1" class="{offset < offsetValStarFadeIn ? 'st4' : 'st4b'}" width="32.7" height="7.2"/>
				 <polygon class="{offset < offsetValStarFadeIn ? 'st4' : 'st4b'}" points="26.9,169 59.6,169.1 70.1,158.3 37.4,158.3 			"/>
			 </g>
			 <g class="Texture" class:show="{offset < offsetValStarFadeIn}">
				 <line class="st5" x1="56.7" y1="161.4" x2="56.7" y2="163.9"/>
				 <line class="st5" x1="42.8" y1="160.9" x2="42.8" y2="163.4"/>
				 <line class="st5" x1="36.3" y1="164.6" x2="36.3" y2="167.1"/>
			 </g>
			 <g id="Cactus_2" class="{offset < offsetValStarFadeIn ? 'st6' : 'st6b'} cactus">
				<path class="st7" d="M57.9,151.4c0.3-7.5-3.3-10.9-7.3-11.1s-7.9,2.9-8.3,10.4c-0.2,5.4,1.2,11.6,3.8,14.7c1,1.2,2.1,1,3.3,1
				c1.3,0.1,2.5,0.3,3.6-0.8C55.7,162.7,57.7,156.7,57.9,151.4z"/>
				<path class="st8" d="M48.5,166.3c-5.2-20.8,2.1-26,2.1-26s7.8,1.6,1.1,25.8"/>
				<g>
					<line class="st7" x1="43.5" y1="160.2" x2="41.8" y2="160.2"/>
					<line class="st7" x1="42.3" y1="152.8" x2="40" y2="151.7"/>
					<line class="st7" x1="43.5" y1="145" x2="41.8" y2="143.6"/>
					<line class="st7" x1="54.1" y1="141.4" x2="55.3" y2="140.3"/>
					<line class="st7" x1="57" y1="145" x2="58.7" y2="144.4"/>
					<line class="st7" x1="58" y1="150.9" x2="59.5" y2="150.6"/>
					<line class="st7" x1="47.4" y1="145" x2="46.3" y2="144.3"/>
					<line class="st7" x1="45.9" y1="152.8" x2="44.9" y2="151.7"/>
					<line class="st7" x1="46.8" y1="159" x2="45.8" y2="159.5"/>
					<path class="st7" d="M54.1,146c0,0,1.2-0.6,1-0.5"/>
					<line class="st7" x1="54.3" y1="153.4" x2="55.6" y2="152.9"/>
					<line class="st7" x1="53.4" y1="159.3" x2="54.3" y2="159.5"/>
					<line class="st7" x1="56" y1="160.8" x2="57" y2="161.4"/>
					<line class="st7" x1="48.4" y1="140.6" x2="47.6" y2="139.3"/>
				</g>
			 </g>
		 </g>
		 <g id="Square1">
			 <g id="SquareBase1">
				 <rect x="59.7" y="169.1" class="{offset < offsetValStarFadeIn ? 'st4' : 'st4b'}" width="32.7" height="7.2"/>
				 <polygon class="{offset < offsetValStarFadeIn ? 'st4' : 'st4b'}" points="59.6,169 92.3,169.1 102.8,158.3 70.2,158.3 			"/>
				 <polygon class="{offset < offsetValStarFadeIn ? 'st4' : 'st4b'}" points="92.3,169 92.3,176.3 102.8,165.8 102.8,158.3 			"/>
			 </g>
			 <g class="Texture" class:show="{offset < offsetValStarFadeIn}">
				 <line class="st5" x1="89.4" y1="161.4" x2="89.4" y2="163.9"/>
				 <line class="st5" x1="78.3" y1="160.9" x2="78.3" y2="163.4"/>
				 <line class="st5" x1="69" y1="164.6" x2="69" y2="167.1"/>
			 </g>
			 <g id="Cactus1" class="{offset < offsetValStarFadeIn ? 'st6' : 'st6b'} cactus">
				<path class="st7" d="M75.1,151.4c-0.3-7.5,3.3-10.9,7.3-11.1s7.9,2.9,8.3,10.4c0.2,5.4-1.2,11.6-3.8,14.7c-1,1.2-2.1,1-3.3,1
				c-1.3,0.1-2.5,0.3-3.6-0.8C77.3,162.7,75.4,156.7,75.1,151.4z"/>
				<path class="st8" d="M84.6,166.3c5.2-20.8-2.1-26-2.1-26s-7.8,1.6-1.1,25.8"/>
				<g>
					<line class="st7" x1="89.5" y1="160.2" x2="91.3" y2="160.2"/>
					<line class="st7" x1="90.8" y1="152.8" x2="93" y2="151.7"/>
					<line class="st7" x1="89.5" y1="145" x2="91.3" y2="143.6"/>
					<line class="st7" x1="78.9" y1="141.4" x2="77.7" y2="140.3"/>
					<line class="st7" x1="76.1" y1="145" x2="74.4" y2="144.4"/>
					<line class="st7" x1="75" y1="150.9" x2="73.6" y2="150.6"/>
					<line class="st7" x1="85.7" y1="145" x2="86.7" y2="144.3"/>
					<line class="st7" x1="87.1" y1="152.8" x2="88.1" y2="151.7"/>
					<line class="st7" x1="86.2" y1="159" x2="87.3" y2="159.5"/>
					<path class="st7" d="M78.9,146c0,0-1.2-0.6-1-0.5"/>
					<line class="st7" x1="78.8" y1="153.4" x2="77.4" y2="152.9"/>
					<line class="st7" x1="79.7" y1="159.3" x2="78.8" y2="159.5"/>
					<line class="st7" x1="77" y1="160.8" x2="76.1" y2="161.4"/>
					<line class="st7" x1="84.7" y1="140.6" x2="85.5" y2="139.3"/>
				</g>
			 </g>
		 </g>
	 </g>
	 <g id="MachineFront_00000130647122002242638630000016786729489780633508_">
		 <rect id="MachineFront" x="120.1" y="143.3" class="st1" width="80" height="36.9"/>
		 <polygon class="st17" points="200.1,143.2 200.1,148.4 218,130.5 218,125.1 	"/>
		 <polygon class="st1" points="120.1,143.2 200.1,143.3 218,125.1 138,125.1 	"/>
	 </g>
</svg>

<style lang="scss">
    #IlloTurf {
		.st0{display:none;fill:#DED9CD;}
		.st1{fill:#ABABAB;stroke:#000000;stroke-width:1.4;stroke-linejoin:round;}
		.st2{fill:#DED9CD;stroke:#303030;stroke-width:1.4;stroke-linejoin:round;}
		.st3{fill:none;stroke:#303030;stroke-width:1.2;stroke-linecap:round;}
		.st4{fill:#76B238;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}
		.st5{fill:none;stroke:#000000;stroke-width:1.2;}
		.st6{opacity:0;}
		.st7{fill:#76B238;stroke:#000000;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;}
		.st8{fill:none;stroke:#000000;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;}
		.st9{fill:#B73764;stroke:#000000;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;}
		.st10{fill:#B73764;stroke:#000000;stroke-width:0.8;stroke-linecap:round;stroke-linejoin:round;}
		.st11{display:none;}
		.st12{display:inline;fill:#B73764;stroke:#000000;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;}
		.st13{display:inline;fill:#76B238;stroke:#000000;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;}
		.st14{fill:#FFFFFF;stroke:#000000;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;}
		.st15{fill:#FFFFFF;stroke:#000000;stroke-width:1.2;stroke-linecap:round;}
		.st16{fill:#FFFFFF;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;}
		.st17{fill:#DED9CD;stroke:#000000;stroke-width:1.4;stroke-linejoin:round;}
		.st4b{fill:var(--color-dirt);stroke:#000000;stroke-width:1.4;stroke-linecap:round;stroke-linejoin:round;}
		.st6b{opacity: 1;}
    }

    #Stars1, #Stars2, #Stars3 {
		opacity: 0;
        &.show {
            opacity: 1;
        }	
	}
    
    .Texture {
        opacity: 0;
        transition: opacity 0.2s, transform 0.2s;
        &.show {
            opacity: 1;
        }	
    }

	#Stars1 {
        transition: opacity 0.2s;
	}
	#Stars2 {
        transition: opacity 0.4s;
	}
	#Stars3 {
        transition: opacity 0.6s;
	}
	mark {
        padding: 0.5em;
        position: fixed;
        top: 0;
        right: 0;
    }

</style>